import {
  RRIBatchOption,
  RRICustomBatchOptionSettings,
  RRIDeleteBatchOptionSettings,
  RRIDownloadBatchOptionSettings,
  RRIUpdateBatchOptionSettings,
} from './batch-options.interface';
export interface RRTableBatchOptions<T, R> {
  delete?: RRIBatchOption<RRIDeleteBatchOptionSettings<T>>;
  download?: RRIBatchOption<RRIDownloadBatchOptionSettings<T, R>>;
  update?: RRIBatchOption<RRIUpdateBatchOptionSettings<T>>;
  custom?: RRIBatchOption<RRICustomBatchOptionSettings<T>[]>;
}
